<template>
    <section class="section">
        <div class="spring spring--narrow">
            <div class="js-component-component component__component" data-component="world-traveller-bundle">
                <div class="bundle">
                    <h3 class="visually-hidden">Oferta</h3>
                    <div class="bundle__summary">
                        <div class="bundle-data bundle-data--small bundle-data--red bundle-data__value--small">
                            <div class="bundle-data__value bundle-data__value">
                                <span class="visually-hidden">Include</span>
                                <div class="bundle-data__heading" tabindex="0">
                                    <span class="bundle-data__amount">0,05</span>
                                    <span class="bundle-data__unit">€</span>
                                </div>
                                credit / minut <br />
                                apelat
                            </div>
                            <div class="bundle-data__value bundle-data__value bundle-data--red bundle-data__value--small bundle-data__value--l-border">
                                <div class="bundle-data__heading">
                                    <span class="bundle-data__amount">0,01€</span>
                                </div>
                                credit / minut <br />
                                primit
                            </div>
                        </div>
                        <div class="bundle-title">
                            <div class="bundle-title__row">
                                <h4 class="heading heading--4 heading--light heading--leading heading--trailing">
                                    Ofertă
                                    <strong>2</strong>
                                </h4>
                            </div>
                        </div>
                        <p class="bundle-price">
                            <span class="visually-hidden">Costul pachetului</span>
                            <strong class="bundle-price__cost">2€ <span class="heading--4 heading--light heading--leading heading--trailing">credit</span></strong>
                            <span class="offer-validity--text">14 zile valabilitate</span>
                        </p>
                    </div>
                    <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                        <div class="js-accordion-content show-more__content" v-show="toggle_prepaid_extins">
                            <p class="visually-hidden">Include</p>
                            <p class="text-center">
                                <span class="tooltip__info-text">Beneficii în Spațiul Economic European (SEE)</span>
                                <span class="tooltip-img" data-tippy-content="Țările SEE: Austria, Azore, Belgia, Bulgaria, Cehia, Cipru, Croația, Danemarca, Estonia, Finlanda, Franța, Germania, Grecia, Guadelupa, Guyana Franceză, Insula Sfântul Martin, Insulele Åland, Insulele Canare, Insulele Reunion, Irlanda, Islanda, Italia, Letonia, Liechtenstein, Lituania, Luxemburg, Madeira, Malta, Martinica, Mayotte, Norvegia, Olanda, Polonia, Portugalia, Slovacia, Slovenia, Spania, Suedia, Ungaria"></span>
                            </p>
                            <ul class="list list--reset bundle__inclusions">
                                <li class="bundle__inclusion bundle__small-padding flush--top">
                                    <img src="https://static.vodafone.ro/roaming/images/v546117.png" alt class="icon bundle__inclusion-bullet" />
                                    Oferă acces la serviciul roaming și la tarifele speciale de mai jos, în Spațiul Economic European:<br />0,05€ credit / minut apelat; 0,01€ credit / minut primit; 0,02€ credit SMS trimis; 0,02€ credit MB
                                </li>
                            </ul>
                        </div>
                        <button-more @click.native="toggle_prepaid_extins = !toggle_prepaid_extins" :more="toggle_prepaid_extins" prefix="Arată mai"></button-more>
                    </div>
                    <div class="bundle__select bundle__select--first">
                        <a :href="hrefActivate" class="button button--secondary button--full-width">Activează opțiunea</a>
                    </div>
                </div>
                <!-- new implementation end -->
            </div>
        </div>
    </section>
</template>

<script>
import ButtonMore from './ButtonMore.vue';
export default {
    name: 'OfferPrepaid_1',
    components: {
        ButtonMore,
    },
    data() {
        return {
            toggle_offer: false,
            toggle_prepaid_extins: false,
            hrefActivate: this.$root.hrefActivate,
        };
    },
    methods: {
        expand() {
            this.toggle_offer = true;
        },
    },
    mounted() {
        this.$root.$on('prepare-for-pdf', this.expand);
    },
    beforeDestroy() {
        this.$root.$off('prepare-for-pdf', this.expand);
    },
};
</script>
